// extracted by mini-css-extract-plugin
export default {"wrapper":"TextFieldAddExpense_wrapper__Y3+UC","input":"TextFieldAddExpense_input__5Tnr6","error":"TextFieldAddExpense_error__lduIV"};